module.exports = __webpack_public_path__ + "static/img/navLogo1.6a1787c3.png";